import randomInt from "./functions/randomInt";

export const moveLittle = (min, max, current) => randomInt(Math.max(min, current - 20))(Math.min(max, current + 20));
